import { Component, Output, EventEmitter, Input, forwardRef, ViewChild } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'or-wysiwyg',
    templateUrl: './wysiwyg.component.html',
    styleUrls: ['./wysiwyg.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => WysiwygComponent),
            multi: true
        }
    ],
    standalone: false
})
export class WysiwygComponent implements ControlValueAccessor {

  public Editor = ClassicEditor;

  onChangeValue: (url) => void;

  @Input() data = '';
  @Input() isDisabled = false;
  @Input() formControlName = '';
  // Optional hard limit on visible characters (tags/whitespace excluded, matching messageCount).
  // When set, typing or pasting past the limit is reverted; deletions are always allowed.
  @Input() maxLength: number | null = null;
  @Output() messageEvent = new EventEmitter<string>();
  @Output() messageCount = new EventEmitter<number>();

  @Input() config = {
    placeholder: "Please be as specific as possible.",
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        'blockQuote',
        'undo',
        'redo'
      ]
    },
    language: 'en',
  };

  public onChange( { editor }: ChangeEvent ) {
    const data = editor.data.get();

    if (this.maxLength != null) {
      const newCount = this.getCount(data);
      const prevCount = this.getCount(this.data);
      if (newCount > this.maxLength && newCount > prevCount) {
        editor.execute('undo');
        return;
      }
    }

    this.data = data;
    if (this.formControlName !== '') {
      this.onChangeValue(this.data);
    }

    this.sendMessage();
    this.sendCount();
  }

  constructor() {  }

  writeValue(value: string): void {
    this.data = value ? value : '';
  }
  registerOnChange(fn: any): void {
    this.onChangeValue = fn;
  }
  registerOnTouched(fn: any): void {

  }

  onReady(editor) {
    editor.focus();
  }

  setDisabledState?(isDisabled: boolean): void {

  }

  sendMessage() {
    this.messageEvent.emit(this.data);
  }

  sendCount() {
    this.messageCount.emit(this.getCount(this.data));
  }

  private getCount(data: string): number {
    return (data || '').replace(/<[^>]*>|\s/g, '').length;
  }
}
